<section id="500" class="text-center has-error" style="margin-top: 10%">
  <h2>Unexpected error occurred. Please try after sometime.</h2>
</section>
<div class="clear"></div>
<div class="actionbar" style="margin-top: 10%">
  <button
    type="button"
    id="submitButton2"
    class="mydeqbutton right"
    (click)="goBack()"
  >
    <span class="arrow"><i class="fa fa-chevron-right"></i></span>RETURN TO
    mySTUFF
  </button>

  <div class="clear"></div>
</div>
